import { Contractor } from '@/types/contractor'

export type ProfileType = 'manager' | 'client'
export type ClientOrManager = Client | Manager
export type ClientOrManagerDB = ClientDB | ManagerDB

interface ClientDB extends Client {
    ssid: string
}

interface ManagerDB extends Manager {
    ssid: string
}
interface PriceMatrix {
    [ind: string]: {
        Цена: number,
        ВидЦены: number
    }
}
export class Profile<T extends ProfileType> {
    constructor(type: T) {
        this.type = type
    }
    type: T
    id = 0
    email = ''
    fio = ''
    tel = ''
}


export class Manager extends Profile<'manager'> {
    constructor() {
        super('manager')
    }
    region = ''
}

export class Client extends Profile<'client'> {
    constructor() {
        super('client')
    }
    otgr = 0
    sale_rus = ''
    sale_imp = ''
    sale_elec = ''
    cart = ''
    Company = ''
    city = ''
    street = ''
    house = ''
    room = ''
    'zip-postal' = ''
    status: '0' | '1' = '0'
    manager: Manager | undefined = undefined
    c1code = ''
    price_matrix: PriceMatrix = {}
    contractors: Contractor[] = []
}

